export const PRODUCTS_FIELD = {
  calls: 'FionaCalls',
  tags: 'FionaAudits (Tags)',
  app: 'FionaBudgets',
  posts: 'FionaPosts',
  onboarding: '',
};

// Widget IDs are ID of the widgets in Freshdesk, not the form's ID
// Go to Freshdesk > Admin > Widgets > Select the widget you want to use > Copy the ID from the URL
export const FRESHDESK_WIDGETS_ID = {
  calls: '63000001788',
  tags: '63000001789',
  app: '63000001789',
  posts: '63000001771',
  onboarding: '63000001805',
};
